import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { ToastProvider } from './components/ui/Toast'
import { useBrandingStore } from './store/branding'

export function App() {
  const loadBranding = useBrandingStore(s => s.loadBranding)

  useEffect(() => {
    loadBranding()
  }, [loadBranding])

  return (
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  )
}
